import {
  NullableRoomAnyId,
  nullableRoomAnyId,
  RtmpDestinationEntityId,
  rtmpDestinationEntityId,
  rtmpDestinationKey,
  RtmpDestinationKey,
  rtmpDestinationUrl,
  RtmpDestinationUrl
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseRequestDTO } from "@youm-front/common/domain";

export class RtmpDestinationUpdateRequestDTO extends BaseRequestDTO<RtmpDestinationUpdateRequestDTORaw> {
  private static validateFunction = JsonSchemaValidator.compile(
    RtmpDestinationUpdateRequestDTO.validationSchema()
  );

  constructor(value: RtmpDestinationUpdateRequestDTORaw) {
    super(
      JsonSchemaValidator.assert(
        RtmpDestinationUpdateRequestDTO.validateFunction,
        value
      )
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["id"],
      properties: {
        id: rtmpDestinationEntityId,
        url: rtmpDestinationUrl,
        key: rtmpDestinationKey,
        roomId: nullableRoomAnyId
      },
      additionalProperties: false
    };
  }

  override toJSON(): object {
    return {
      type: "rtmp",
      destination: {
        roomId: this.value.roomId,
        url: this.value.url,
        key: this.value.key
      }
    };
  }
}

interface RtmpDestinationUpdateRequestDTORaw {
  id: RtmpDestinationEntityId;
  url?: RtmpDestinationUrl;
  key?: RtmpDestinationKey;
  roomId?: NullableRoomAnyId;
}
